<template>


    <div >
        <transition name="fade">
    <div class="viewer-nav-overlay" v-show="valveMenuShowing" >

        <button class="js-close-viewer-nav viewer-nav-overlay__btn-close" v-on:click="hideProductMenu" v-if="this.$route.name != 'home'"><i class="icon-close"></i></button>


        <div class="viewer-nav-overlay-drawers">

            <div class="viewer-nav-welcome" v-if="this.$route.name == 'home'">
                <h1 class="viewer-nav-welcome__title">Welcome to the ACS 3D Gallery</h1>
                <p>Get the full 360 view of our rotary airlock valves for pneumatic conveying systems.<br><strong>Click on a valve or option to get started.</strong></p>
            </div>

            <div class="viewer-nav-search visible" search-type="valves">
                <div>
                    <form id="search" aria-label="Product search">
                        <input name="query" id="product-search" placeholder="Search by name" v-model="searchQuery" autocomplete="off">
                        <i class="icon-search" role="none"></i>
                    </form>
                </div>
            </div>

            <div class="viewer-nav-overlay-drawer visible" id="valves">

                <div class="loading" v-if="loading">
                    Loading valve list...
                </div>




                <valve-tile
                        v-for="(valve, index) in filteredValves"
                        v-bind:key="valve.slug + '_' + index"
                        v-bind:valve="valve"
                        :filter-key="searchQuery"
                        v-on:hide-product-menu="hideProductMenu"
                ></valve-tile>

                <valve-tile
                        v-for="(option, index) in filteredOptions"
                        v-bind:key="option.slug + '_' + index"
                        v-bind:valve="option"
                        :filter-key="searchQuery"
                        v-on:hide-product-menu="hideProductMenu"
                ></valve-tile>





            </div>
        </div>





    </div>
        </transition>


        <transition name="router-anim" enter-active-class="animated fadeInDown" leave-active-class="animated fadeOutDown" mode="out-in" >
        <router-view v-bind:key="$route.params.id"></router-view>
        </transition>


    </div>

</template>

<script>
// @ is an alias to /src
import ValveTile from '@/components/ValveTile.vue'
import axios from 'axios'



export default {
  name: 'valves',
    data() {
        return {
            searchQuery: '',
            valveMenuShowing: false,
            loading: false,
            valves: [],
            options: [],
            filterKey: ''
        }
    },
    methods: {
//        getPosts() {
//
//        },
        showProductMenu(){
            this.valveMenuShowing = true
            document.getElementById('product-search').val = '';
        },
        hideProductMenu(){
            this.valveMenuShowing = false
        },
        getValves(){

            var browser = function() {
                // Return cached result if avalible, else get result then cache it.
                if (browser.prototype._cachedResult)
                    return browser.prototype._cachedResult;

                // Opera 8.0+
                var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;

                // Firefox 1.0+
                var isFirefox = typeof InstallTrigger !== 'undefined';

                // Safari 3.0+ "[object HTMLElementConstructor]"
                var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || safari.pushNotification);

                // Internet Explorer 6-11
                var isIE = /*@cc_on!@*/false || !!document.documentMode;

                // Edge 20+
                var isEdge = !isIE && !!window.StyleMedia;

                // Chrome 1+
                var isChrome = !!window.chrome && !!window.chrome.webstore;

                // Blink engine detection
                var isBlink = (isChrome || isOpera) && !!window.CSS;

                return browser.prototype._cachedResult =
                    isOpera ? 'Opera' :
                    isFirefox ? 'Firefox' :
                    isSafari ? 'Safari' :
                    isChrome ? 'Chrome' :
                    isIE ? 'IE' :
                    isEdge ? 'Edge' :
                    isBlink ? 'Blink' :
                    "Don't know";
            };

         if (browser() == 'Edge'){

         } else  if (browser() == 'IE'){
             document.body.classList.add("ie-not-supported")
         }



            this.loading = true
            //console.log("gettin valves");
            return axios.get('/rotary-valves.json')
                .then(response => {
                    this.valves = response.data.data
                    this.loading = false
                })
        },
        getOptions(){
            this.loading = true
            //console.log("gettin valves");
            return axios.get('/rotary-valve-options.json')
                .then(response => {
                    this.options = response.data.data
                    this.loading = false
                })
        },
        showProductMenuOnFirstLoad(){

            // If route is home (no valve selected), show product menu
            if (this.$route.name == 'home'){
                this.showProductMenu()
            } else{
                this.hideProductMenu()
            }
        }
    },
    created() {
        this.getValves()
        this.getOptions()

        if (this.$route.name == 'home'){
            this.showProductMenu()
        }

    },
    asyncComputed: {
        async filteredValves() {
            return this.valves.filter(valve => {
                return valve.title.toLowerCase().includes(this.searchQuery.toLowerCase())
            })
        },
        async filteredOptions() {
            return this.options.filter(option => {
                return option.title.toLowerCase().includes(this.searchQuery.toLowerCase())
            })
        }
    },
//    computed: {
//        filteredData: function () {
//
//        }
//    },
    mounted () {
     // this.getValves()
       // this.getPosts()

    },
    watch: {
        '$route': 'showProductMenuOnFirstLoad'
    },
  components: {
    ValveTile
  }
}
</script>
